<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents">



      <h1 class="l-pageTitle">診断項目マスタ編集</h1>
      <div class="l-contentsBox" v-if="!isRendering">

        <div v-if="$route.name === 'diag-item-master-edit'" class="btn-contentsdelete" @click="deleteItem()">
          <a><img src="@/assets/img/common/icon-x.svg" alt="">この診断項目を削除する</a>
        </div>

        <table class="l-form-table">
          <caption>診断項目マスタ</caption>
          <tr>
            <th class="v-middle"><span>条名称</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;">{{ diagItem.diagSubSection.diagSection.sortOrder }}. {{ diagItem.diagSubSection.diagSection.sectionNm }}</span>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>項名称</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;">{{ diagItem.diagSubSection.sortOrder }}. {{ diagItem.diagSubSection.subSectionNm }}</span>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>対象者</span></th>
            <td class="v-middle">
              <div class="l-inputAccount" style="width:100%;">
                <TextBox v-model="$v.diagItem.$model.subjects" @input="$v.diagItem.$touch()" style="width: 500px;" />
                <ValidationErrorMessage v-show="$v.diagItem.subjects.$error" validation="required" />
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>チェック項目</span></th>
            <td class="v-middle">
              <div class="l-inputAccount" style="width:100%;">
                <TextArea v-model="$v.diagItem.$model.checkItem" @input="$v.diagItem.$touch()" class="auto-height l-formGroup__textArea" />
                <ValidationErrorMessage v-show="$v.diagItem.checkItem.$error" validation="required" />
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>対応</span></th>
            <td class="v-middle">
              <div class="l-inputAccount" style="width:100%;">
                <TextArea v-model="$v.diagItem.$model.remediation" @input="$v.diagItem.$touch()" class="auto-height l-formGroup__textArea" />
              </div>
            </td>
          </tr>
         <tr>
            <th class="v-middle"><span>リスク度</span></th>
            <td class="v-middle">
              <div class="l-select w-auto">
                <SelectBox v-model="$v.diagItem.$model.riskLevelId"
                  :options="riskLevelList"
                  :selectedValue="diagItem.riskLevelId"
                  :needsBlank=false>
                </SelectBox>
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>ガイドコード</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.diagItem.$model.guideCd" @input="$v.diagItem.$touch()" />
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>対応条文</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.diagItem.$model.provisions" @input="$v.diagItem.$touch()" />
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>条</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.diagItem.$model.provisionsSection" @input="$v.diagItem.$touch()" />
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>項</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.diagItem.$model.provisionsSubSection" @input="$v.diagItem.$touch()" />
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>e-Gov条文(システムで設定)</span></th>
            <td class="v-middle">
              <div class="btn-basic is-small is-inlne" @click="showEgovProvision(true)" :class="{'gray-out': !diagItem.provisionsDetail}" style="padding-left: 20px;">
                <a :class="{'gray-out': !diagItem.provisionsDetail}">対応条文 e-Gov</a>
              </div>
              <div class="btn-basic is-small is-inlne" style="padding-left: 20px;" @click="getProvisionsFromEgov()"><a>e-Govから条文を取得</a></div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>課題</span></th>
            <td class="v-middle">
              <div class="l-inputAccount" style="width:100%;">
                <TextArea v-model="$v.diagItem.$model.task" @input="$v.diagItem.$touch()" class="auto-height l-formGroup__textArea" />
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>改善の方向性</span></th>
            <td class="v-middle">
              <div class="l-inputAccount" style="width:100%;">
                <TextArea v-model="$v.diagItem.$model.specificMeasures" @input="$v.diagItem.$touch()" class="auto-height l-formGroup__textArea" />
              </div>
            </td>
          </tr>

         <tr>
            <th class="v-middle"><span>IPO重要度</span></th>
            <td class="v-middle">
              <div class="l-select w-auto">
                <SelectBox v-model="$v.diagItem.$model.ipoImportanceId"
                  :options="ipoImportanceList"
                  :selectedValue="diagItem.ipoImportanceId"
                  :needsBlank=false>
                  </SelectBox>
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>現状/課題の例文</span></th>
            <td class="v-middle">
              <div class="l-inputAccount" style="width:100%;">
                <TextArea v-model="$v.diagItem.$model.sampleComment" @input="$v.diagItem.$touch()" class="auto-height l-formGroup__textArea" />
                <ValidationErrorMessage v-show="$v.diagItem.sampleComment.$error && !$v.diagItem.sampleComment.maxLength" validation="maxLength" valueLength="500" />
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>改善の方向性(IPO版)</span></th>
            <td class="v-middle">
              <div class="l-inputAccount" style="width:100%;">
                <TextArea v-model="$v.diagItem.$model.specificMeasuresForIpo" @input="$v.diagItem.$touch()" class="auto-height l-formGroup__textArea" />
              </div>
            </td>
          </tr>


          <tr>
            <th class="v-middle"><span>監査番号（並び順）</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">{{ diagItem.sortOrder ? diagItem.sortOrder : '最後尾に追加されます' }}</div>
            </td>
          </tr>
          <tr v-if="isAllPermission">
            <th class="v-middle"><span>Excel項目番号</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.diagItem.$model.xlsItemNo" @input="$v.diagItem.$touch()" />
                <ValidationErrorMessage v-show="$v.diagItem.xlsItemNo.$error && !$v.diagItem.xlsItemNo.required" validation="required" />
              </div>
            </td>
          </tr>

          <tr>
            <th class="v-middle"><span>回答項目設定</span></th>
            <td class="v-middle">
              <label class="l-checkbox">
                <CheckBox v-model="$v.diagItem.$model.isMemo" :value="true" :checked="$v.diagItem.$model.isMemo" labelText="現状のみ" />
              </label>
            </td>
          </tr>

        </table>
        <table class="l-form-table" style="width:100%;">
          <caption>レーダーチャート</caption>
          <colgroup>
            <col style="width: 15%;">
            <col>
          </colgroup>
          <template v-for="diagChartCategory in diagChartCategories">
            <SelectDiagChartCategory
              :itemId="itemId"
              :diagChartCategory="diagChartCategory"
              @check-diag-chart-category-detail-id="checkDiagChartCategoryDetailId"
              :key="diagChartCategory.diagChartCategoryId">
            </SelectDiagChartCategory>
          </template>
        </table>

        <!-- ソリューション -->
        <SolutionSelectTable
          :solutionList="solutionList"
          @check-solution-id="checkSolutionId"
        >
        </SolutionSelectTable>
        <div class="l-contentsBox__bottom" style="text-align: center;">
          <div class="btn-basic is-inlne mt-20 is-primary js-savebtn" @click="register()"><a>更新</a></div>
        </div>
      </div>
    </div>
    <transition name="egovprovisionmodal-fade">
      <EgovProvisionsModal
        v-if="isShowEgovProvision"
        :itemId="diagItem.itemId"
        @hide-egov-provision-modal="showEgovProvision(false)"
      ></EgovProvisionsModal>
    </transition>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import TextBox from '@/components/parts/form/TextBox.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import SelectBox from '@/components/parts/form/SelectBox.vue';
import CheckBox from '@/components/parts/form/CheckBox.vue';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import { required, maxLength } from 'vuelidate/lib/validators';
import SelectDiagChartCategory from '@/components/parts/master/SelectDiagChartCategory.vue';
import SolutionSelectTable from '@/components/parts/master/SolutionSelectTable.vue';
import EgovProvisionsModal from '@/components/parts/master/EgovProvisionsModal.vue';

export default {
  components: {
    Loading,
    TextBox,
    TextArea,
    SelectBox,
    CheckBox,
    ValidationErrorMessage,
    SelectDiagChartCategory,
    SolutionSelectTable,
    EgovProvisionsModal,
  },
  data() {
    return {
      isProcessing: false,
      isRendering: false,
      isAllPermission: false,
      isShowEgovProvision: false,
      diagItem: {
        subjects: '',
        checkItem: '',
        remediation: '',
        riskLevelId: null,
        guideCd: '',
        provisions: '',
        provisionsSection: '',
        provisionsSubSection: '',
        provisionsDetail: '',
        task: '',
        sampleComment: '',
        specificMeasures: '',
        xlsItemNo: '',
        diagSubSection: {
          subSectionNm: '',
          diagSection: {
            sectionNm: '',
          },
        },
        isMemo: false,
      },
      riskLevelList: [],
      ipoImportanceList: [],
      diagChartCategories: [],
      selectDiagChartCategoryDetailIds: [],
      solutionList: [],
      selectSolutionIds: [],
    }
  },
  computed: {
    itemId() {
      return this.$store.getters['master/getItemId'];
    },
    sectionId() {
      return this.$store.getters['master/getSectionId'];
    },
    subSectionId() {
      return this.$store.getters['master/getSubSectionId'];
    },
  },
  validations: {
    diagItem: {
      subjects: {  },
      checkItem: { required },
//      remediation: { required },
      guideCd: { },
      provisions: { },
      provisionsSection: { },
      provisionsSubSection: { },
      task: { },
      sampleComment: { maxLength: maxLength(500) },
      specificMeasures: { },
      xlsItemNo: { required },
    }
  },
  created: async function() {
    this.isRendering = true;
    this.isProcessing = true;
    const authority = await this.$store.dispatch('auth/getAuthority')
    this.isAllPermission = authority.isAllPermission;
    await this.getDiagItem(this.itemId);
    this.$nextTick(() => {
      this.isRendering = false;
      this.isProcessing = false;
    });
  },
  methods: {
    async getDiagItem(itemId) {
      let res = await this.$axios.post('/ld/api/master/diag/getDiagItemEdit', {
        itemId: itemId,
        sectionId: this.sectionId,
        subSectionId: this.subSectionId,
      });
      if (res) {
        this.diagItem = res.data.diagItem;
        this.riskLevelList = res.data.riskLevelList;
        this.ipoImportanceList = res.data.ipoImportanceList;
        this.diagChartCategories = res.data.diagChartCategories;
        this.selectDiagChartCategoryDetailIds = res.data.selectDiagChartCategoryDetailIds;
        this.solutionList = res.data.solutionList;
        this.selectSolutionIds = this.solutionList.filter(solution => solution.solutionDiagItemId)
          .map(solution => solution.solutionId);
      }
    },

    async deleteItem() {
      if (window.confirm("削除しますか？")) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/master/diag/storeDiagItemDelete', {
          itemId: this.itemId,
        });
        if (res.status === 200) {
          this.$store.dispatch('alert/setMessage', '削除しました');
          this.$router.push({ name: 'diage-section-master-delete-list' });
        } else {
          this.$toast.error(res.data.message);
        }
        this.isProcessing = false;
      }
    },

    async register() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/master/diag/storeDiagItem', {
          diagItem: this.diagItem,
          sectionId: this.sectionId,
          subSectionId: this.subSectionId,
          selectDiagChartCategoryDetailIds: this.selectDiagChartCategoryDetailIds,
          selectSolutionIds: this.selectSolutionIds,
        });
        if (res.status === 200) {
          this.$toast.info('登録が完了しました');
          if (this.$route.name === 'diag-item-master-new') {
            this.$store.dispatch('master/setItemId', res.data.diagItem.itemId);
            this.$router.push({ name: 'diag-item-master-edit' });
          }

          this.isRendering = true;
          await this.getDiagItem(res.data.diagItem.itemId);
          this.$nextTick(() => {
            this.isRendering = false;
            this.isProcessing = false;
          });
        } else {
          this.$toast.error(res.data.message);
        }
        this.isProcessing = false;
      }
    },
    checkDiagChartCategoryDetailId(params) {
      if (params.checked) {
        this.selectDiagChartCategoryDetailIds.push(params.value);
      } else {
        this.selectDiagChartCategoryDetailIds = this.selectDiagChartCategoryDetailIds.filter(v => v != params.value);
      }
    },
    checkSolutionId(params) {
      if (params.checked) {
        this.selectSolutionIds.push(params.value);
      } else {
        this.selectSolutionIds = this.selectSolutionIds.filter(v => v != params.value);
      }
    },
    async getProvisionsFromEgov() {
      if (!this.diagItem.provisions || !this.diagItem.provisionsSection) {
        this.$toast.error('対応条文と条を入力してください。');
        return;
      }
      const ans = confirm('e-Govから条文を取得しますか？');
      if (!ans) return;

      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/master/diag/getProvisionsFromEgov', {
        itemId: this.itemId,
        provisions: this.diagItem.provisions,
        provisionsSection: this.diagItem.provisionsSection,
        provisionsSubSection: this.diagItem.provisionsSubSection,
      });
      if (res.status === 200) {
        this.$toast.info('条文を取得しました。');

        this.isRendering = true;
        this.isProcessing = true;
        await this.getDiagItem(this.itemId);

        this.$nextTick(() => {
          this.isRendering = false;
          this.isProcessing = false;
        });
      } else {
        this.$toast.error(res.data.message)
      }
      this.isProcessing = false;
    },
    showEgovProvision(value) {
      this.isShowEgovProvision = value;
    },
  }
}

</script>

<style scoped>
.egovprovisionmodal-fade-enter-active {
  transition: all .2s ease;
}
.egovprovisionmodal-fade-leave-active {
  transition: all .2s ease;
}
.egovprovisionmodal-fade-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}
.egovprovisionmodal-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}

.gray-out {
  pointer-events: none;
}
.gray-out a {
  border: 1px solid #6a6a6a ;
  color: #a9a9a9;
}
</style>
